import { BATCH_STATUS } from "../pages/batches/components/FilteringBatchesDialog";

export const isBatchReadOnly = (batchState?: string | null): boolean =>
  batchState === BATCH_STATUS.VERIFIED.name;
